import z from "zod";

export const QuotationFormSchema = z.object({
    project_id: z.string().nullable(),
    project_name: z.string().min(1, "Project Name is required"),
    quotation_date: z.string().min(1, "Quotation date is required"),
    quotation_to_id: z.string().min(1, "Client is required"),
    reference_number: z.string(),
    subject: z.string().min(1, "Subject is required"),
    items: z.array(
        z.object({
            sno: z.number().min(1, "number is required"),
            quantity: z.number().min(1, "Quantity is required"),
            description: z.string().min(1, "Description is required"),
            uom: z.string().min(1, "Unit is required"),
            unit_price: z.number().min(1, "Unit price is required"),
            tax: z.number().default(15),
        }),
    ),
    terms_and_conditions: z.array(
        z.object({
            value: z.string().min(3, "Terms and conditions is required"),
        }),
    ),
    recipient_designation: z
        .string()
        .min(1, "Recipient designation is required"),
    recipient_name: z.string().min(1, "Recipient name is required"),
    location: z.string().min(1, "Location is required"),
});

export const CreateQuotationSchema = QuotationFormSchema.omit({
    terms_and_conditions: true,
}).extend({
    terms_and_conditions: z.array(z.string()),
});

export type QuotationFormSchema = z.infer<typeof QuotationFormSchema>;
export type CreateQuotationSchema = z.infer<typeof CreateQuotationSchema>;
